import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useDispatch, useSelector } from 'react-redux';
import { ButtonV2, H1, H2, H3, Modal, P, formatISODateStringAsUSMonthDayYear, } from 'shared';
import { setPersonalInfo, setPersonalInfoOTA } from '../actions';
import { selectors } from '../reducer';
function ConfirmInfoModal({ isOpen, setIsOpen, overlappingFields, setIsProvePrefilled, setPrefillSource, }) {
    const dispatch = useDispatch();
    const personalInfoOTA = useSelector(selectors.personalInfoOTA);
    const handleUseProveFields = () => {
        setIsOpen(false);
        dispatch(setPersonalInfoOTA(undefined));
        setPrefillSource('Prove');
    };
    const handleUseOtaFields = () => {
        setIsOpen(false);
        setIsProvePrefilled(false);
        dispatch(setPersonalInfo(personalInfoOTA));
        dispatch(setPersonalInfoOTA(undefined));
        setPrefillSource('OTA');
    };
    const handleEnterManually = () => {
        setIsOpen(false);
        setIsProvePrefilled(false);
        dispatch(setPersonalInfo(null));
        dispatch(setPersonalInfoOTA(undefined));
    };
    const proveDate = formatISODateStringAsUSMonthDayYear(overlappingFields.proveFields.dateOfBirth);
    const otaDate = formatISODateStringAsUSMonthDayYear(overlappingFields.otaFields.dateOfBirth);
    const proveFields = {
        fullName: overlappingFields.proveFields.firstName +
            ' ' +
            overlappingFields.proveFields.lastName,
        dateOfBirth: proveDate ?? '',
    };
    const otaFullName = overlappingFields.otaFields.firstName &&
        overlappingFields.otaFields.lastName
        ? overlappingFields.otaFields.firstName +
            ' ' +
            overlappingFields.otaFields.lastName
        : '(Not Provided)';
    const otaFields = {
        fullName: otaFullName,
        dateOfBirth: otaDate ?? '',
    };
    return (_jsx(Modal, { isOpen: isOpen, setIsOpen: setIsOpen, withHandle: true, onRequestClose: handleEnterManually, children: _jsxs("div", { className: "flex dir-col justify-start align-center confirm-info-modal", children: [_jsx(H1, { variant: "headline-large", className: "text-center", children: "Confirm Your Information" }), _jsx(P, { variant: "body-large", className: "text-center mar-b-24 pad-8", children: "We found differences between what you submitted and the data linked to your phone number. Please take a moment to review and confirm." }), _jsxs("div", { className: "prefilled-info", children: [_jsx(PrefilledInfoSet, { dataSource: "OTA", fields: otaFields, otherFields: proveFields, handleUseFields: handleUseOtaFields }), _jsx("div", { className: "divider" }), _jsx(PrefilledInfoSet, { dataSource: "Prove", fields: proveFields, otherFields: otaFields, handleUseFields: handleUseProveFields })] }), _jsxs("div", { className: "or-line-container", children: [_jsx("div", { className: "or-line" }), _jsx(P, { variant: "title-medium", className: "color-gray mar-right-8 mar-left-8", children: "Or" }), _jsx("div", { className: "or-line" })] }), _jsx("div", { className: "button-container", children: _jsx(ButtonV2, { variant: "outline", size: "small", fullWidth: true, onClick: handleEnterManually, children: "Enter Manually" }) })] }) }));
}
const PrefilledInfoSet = ({ dataSource, fields, handleUseFields, otherFields, }) => {
    const fieldsDisplayMap = new Map([
        ['fullName', 'Full Name'],
        ['dateOfBirth', 'Date of Birth'],
    ]);
    return (_jsxs("div", { className: "prefilled-info-set", children: [_jsx(H2, { variant: "headline-small", className: "text-center mar-b-16", children: dataSource === 'Prove' ? 'Information Found' : 'Information Submitted' }), Object.keys(fields).map((key) => (_jsxs("div", { className: "prefilled-info-item", children: [_jsx(H3, { variant: "body-large", className: "mar-b-0 mar-right-8 text-no-wrap", bold: true, children: fieldsDisplayMap.get(key) }), _jsx(P, { variant: "body-large", className: fields[key] !==
                            otherFields[key]
                            ? 'highlight'
                            : '', children: fields[key] })] }, key))), _jsx(ButtonV2, { variant: "filled", size: "small", fullWidth: true, onClick: handleUseFields, children: "Use This Information" })] }));
};
export default ConfirmInfoModal;
